import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/klariance.webp';
import screenshot_target from '../../../images/letterfunnel/johankenzeler.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Johan Kenzeler"
      firstname="Johan"
      companyname="Klariance"
      competition="ComplianceWire en Veeva Vault Training"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/johankenzeler.js